import { frontendURL } from '../../../helper/URLHelper';

const PipelinesView = () => import('./PipelinesView.vue');
const Board = () => import('./Board.vue');

const PIPELINE_PERMISSIONS = [
  'administrator',
  'agent',
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines'),
      component: PipelinesView,
      meta: {
        permissions: PIPELINE_PERMISSIONS,
      },
      children: [
        {
          path: '',
          name: 'pipelines_dashboard',
          redirect: 'board',
          meta: {
            permissions: PIPELINE_PERMISSIONS,
          },
        },
        {
          path: 'board',
          name: 'pipelines_board',
          component: Board,
          meta: {
            permissions: PIPELINE_PERMISSIONS,
          },
        },
        {
          path: 'board/:pipelineId',
          name: 'pipeline_board_view',
          component: Board,
          meta: {
            permissions: PIPELINE_PERMISSIONS,
          },
        },
      ],
    },
  ],
};